import apiClient from '../index';

export const userApi = {
  // Get user profile
  getProfile: (id) => apiClient.get(`/user/profile/${id}`),
  
  // Update user profile
  updateProfile: (id, userData) => apiClient.post(`/user/profile-update/${id}`, userData),
  
  // Request account deletion OTP
  requestDeleteOtp: (data) => apiClient.post('/user/account-delete-otp', data),
  
  // Verify and delete account
  deleteAccount: (data) => apiClient.post('/user/account-delete', data),
};

export default userApi;
